import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { Environment } from './types';

/** Region, Bedrock profile, build and modes: facts the footer and the user menu show. */
export function useEnvironment() {
  return useQuery({ queryKey: ['environment'], queryFn: () => api<Environment>('/api/environment'), staleTime: Number.POSITIVE_INFINITY });
}
